<template>
    <div class="container-fluid custom-container" v-if="productDetail != null">
            <div class="row">
                <div class="col-md-12 mobile-view-only">
                    <a ><span @click="backToStore()" class="float-left"><i class="fas fa-arrow-left"></i></span><span data-toggle="modal" data-target="#shareProducts" class="float-right"><i class="fas fa-share-alt mr-2"></i>Share</span></a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="row">
                                <div class="col-md-8 pl-0">
                                    <div class="col-md-12">
                                        <span class="heading-font-size">{{storeName}}</span>
                                        <img src="../assets/img/svg/Icon_awesome-check-circle.svg" class="img-fluid check-circle ml-3 mb-2" alt="Responsive image">
                                    </div>
                                    <div class="col-md-12">
                                        <span class="content-color">{{address}}</span>
                                    </div>   
                                    <div class="col-md-12">
                                        <span class="content-color"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="mb-0"/>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 left-side-bar left-sidebar-in-mobile-view">
                   
                </div>
                <div class="col-md-6 col-sm-12 pt-3 border-left">
                    <div class="row">
                        <div class="col-md-12 left-sidebar-in-mobile-view">
                            <span class="home-dairy-product float-left">Home > Dairy Products > Nestle Everyday Dairy Whitener Milk Powder (200 g)</span>
                            <small class="share-icon float-right"><a href="#"><i class="fas fa-share-alt mr-2"></i>Share This Product</a></small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                                    
                                </ol>
                                <div class="carousel-inner" v-if="productDetail.CoverImageURL != '' && productDetail.CoverImageURL != null ">
                                    <div class="carousel-item active">
                                        <img class="d-block w-100" v-bind:src=productDetail.CoverImageURL alt="First slide">
                                    </div>
                                    <div class="carousel-item">
                                        <img class="d-block w-100" v-bind:src=productDetail.CoverImageURL alt="Second slide">
                                    </div>
                                    <div class="carousel-item">
                                        <img class="d-block w-100" v-bind:src=productDetail.CoverImageURL alt="Third slide">
                                    </div>
                                    
                                </div>
                                <div class="carousel-inner" v-if="productDetail.CoverImageURL == '' || productDetail.CoverImageURL == null ">
                                    <div class="carousel-item active">
                                        <img class="d-block w-100" src="../assets/img/no_image.png" alt="First slide">
                                    </div>
                                    <div class="carousel-item">
                                        <img class="d-block w-100" src="../assets/img/no_image.png" alt="Second slide">
                                    </div>
                                    <div class="carousel-item">
                                        <img class="d-block w-100" src="../assets/img/no_image.png" alt="Third slide">
                                    </div>
                                    
                                </div>
                                <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon product-page" aria-hidden="true"><i class="fas fa-chevron-left"></i></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon product-page" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row mt-2">
                        <div class="col-md-12">
                            <strong>{{productDetail.ProductName}}</strong>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col price mt-2" v-if="productDetail.HasVariants == 'N' || !easyCommerce">
                            <span class="mr-3">Price:</span>
                            <b v-bind:id="productDetail.ProductName" class="mr-3">{{productDetail.CurrencyText}}{{productDetail.OfferPrice}}</b>
                            <small class="text-muted"><del class="mr-3">{{productDetail.CurrencyText}}{{productDetail.MRP}}</del>(inclusive of all taxes)</small>
                        </div>
                         <div class="col price mt-2" v-if="productDetail.HasVariants == 'Y' && easyCommerce">
                            <span  class="mr-3">Price:</span>
                            <b v-bind:id="productDetail.ProductName" class="mr-3">{{productDetail.CurrencyText}}{{productDetail.variant.OfferPrice}}</b>
                            <small class="text-muted"><del v-bind:id="productDetail.ProductHandle" class="mr-3">{{productDetail.currencyText}}{{productDetail.variant.MRP}}</del>(inclusive of all taxes)</small>
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-md-12 price mt-2">
                            <span class="mr-3" v-if="productDetail.HasVariants == 'Y' && easyCommerce">Available in:</span>
                            <div class="quantities mt-1">
                                <!-- eslint-disable -->
                                <button class="product-quantites" v-for="variant in variantList" :class="{'active': productDetail.variant.VariantText == variant.VariantText}" v-if="variant.ProductHandle == productDetail.ProductHandle" v-bind:id="variant.ProductVariantID" @click="variantDetails(variant,productDetail)">{{variant.VariantText}}</button>
                                 <!-- eslint-enable -->
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div @click="addToCartList(productDetail)" class="col-md-12 add-to-cart text-center mt-3">
                            <a ><i class="fas fa-cart-plus mr-3"></i>ADD TO CART<span class="float-right"><i class="fas fa-angle-right"></i></span></a>
                        </div>
                    </div>
                    <div class="row" v-if="productDetail.ProductDescription !='' && productDetail.ProductDescription !=null ">
                        <div class="col-md-12">
                           <strong>Product Description</strong>
                        </div>
                        <div class="col-md-12 descripation">
                           <p>{{productDetail.ProductDescription}}</p>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-md-12">
                           <strong>Ingredients</strong>
                        </div>
                        <div class="col-md-12 descripation">
                           <p>Milk Solids, Sugar, Maltodextrin & Stabilizer</p>
                        </div>
                    </div> -->
                </div>
            </div>
<div class="modal fade modal-add" id="shareProducts" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" style="width:50%;height:140px">
      <div class="modal-header">
        <h6 class="modal-title product-heading-modal" id="exampleModalLongTitle">Share Via -</h6>
        <button type="button" class="close add-more"  data-dismiss="modal" aria-label="Close">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body" style="justify-content: center;display: flex;">
      <i style="font-size:40px;color:#3b5998" class="fab fa-facebook" @click='open("facebook")'></i>
      <i style="font-size:40px;margin-left:20px;color:#25D366" class="fab fa-whatsapp" @click='open("whatsapp")'></i>
      <i style="font-size:40px;margin-left:20px;color:#00acee" class="fab fa-twitter" @click='open("twitter")'></i>
      </div>
    </div>
  </div>
</div>
        </div>
</template>

<script>
export default {
  
  data : function(){
      return {
          storeName : sessionStorage.getItem('StoreName'),
          address : sessionStorage.getItem('StoreAddress'),
          productDetail : [],
          variantList : [],
          variantSelected : null,
          itemList : [],
          easyCommerce : false
      }
  },
  methods: {
      backToStore: function(){
          this.$router.go(-1);
      },
      variantDetails: function(variant,product){
            document.getElementById(product.ProductName).innerHTML=product.CurrencyText + variant.OfferPrice
            document.getElementById(product.ProductHandle).innerHTML=product.CurrencyText + variant.MRP
            document.getElementById(variant.ProductVariantID).classList.add('active')
            for(var i=0;i<this.variantList.length;i++){
                if(this.variantList[i].ProductHandle == product.ProductHandle && this.variantList[i].ProductVariantID != variant.ProductVariantID){
                    document.getElementById(this.variantList[i].ProductVariantID).classList.remove('active')

                }
            }
            this.variantSelected = variant
        },
        addToCartList: function(product){


            if(product.HasVariants == 'Y' && !this.easyCommerce){
                this.$router.push({name:'Home'})
                this.$root.$emit('addedToCart',product)
                return
            }

            if(this.variantSelected == null){
                  for(var i=0;i<this.variantList.length;i++){
                    if(this.variantList[i].ProductHandle == product.ProductHandle){
                        this.variantSelected = this.variantList[i]
                        break
                }
            }
            }

            if(product.HasVariants == 'N'){
                 this.itemList.push({name:product.ProductName,cost:Number(document.getElementById(product.ProductName).innerHTML.split(product.CurrencyText)[1]),quantity:1,variant:0,currency:product.CurrencyText,BH:new Date().getTime(),VID:'',productHandle:product.ProductHandle,PLID:product.BranchPriceListID})
                 this.$root.$emit('ItemSelected',this.itemList)
            }
            else{
               this.itemList.push({name:product.ProductName,cost:this.variantSelected.OfferPrice,quantity:1,variant:this.variantSelected.VariantText,currency:product.CurrencyText,BH:new Date().getTime(),VID:this.variantSelected.ProductVariantID,productHandle:product.ProductHandle,PLID:product.BranchPriceListID})
               this.$root.$emit('ItemSelected',this.itemList)
            }
            this.$router.go(-1);
        },
        open: function(string){
            const title = "InstaCiti Product Share"
            const url = "https://store.instaciti.com/"
            let params = 'scrollbars=no,resizable=no,status=no,location=no,menubar=no,width=600,height=500,left=100,top=100';
            if(string == "facebook"){
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + url + "&title=" + title,'share',params)

            }
            else if(string == "whatsapp"){
                window.open('whatsapp://send?text=' + url,'share',params)

            }
            else if(string == "twitter")
            window.open('https://twitter.com/intent/tweet?text=' + title + '&url=' + url,'share',params)
        },
  },
  mounted() {
      this.productDetail = JSON.parse(sessionStorage.getItem('productDetails'))
      this.variantList = JSON.parse(sessionStorage.getItem('variantSelectedList'))
      console.log(this.productDetail)
      if(sessionStorage.getItem('ECommDS') == 'EASYCOMM1'){
                        this.easyCommerce = true
    }
    else if(sessionStorage.getItem('ECommDS') == 'ECOMM2' || sessionStorage.getItem('ECommDS') == 'ecomm2'){
                        this.easyCommerce = false
    }
  }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
